import React from 'react'
import { observer } from 'mobx-react'
import withTranslations from '../../hoc/withTranslations'
import PropTypes from 'prop-types'
import * as UI from 'ui'
import { useField } from '@morningtrain/react-fields'
import { useValue } from '@morningtrain/react-resources'
import { format } from 'date-fns'
import { Translation } from '@morningtrain/react-translations'
import * as Displays from 'support/displays'

function ActivationChangeDateField (props) {
  let {
    wrap
  } = useField(props)

  return wrap(() =>(
      <UI.Text className='absolute m-0 top-1/2'>
        <Displays.Date name="active_changed_at"  />
      </UI.Text>
    )
  )
}
ActivationChangeDateField.defaultProps = {
  ...useField.defaultProps,
  label: <Translation name="fields.active_changed_at.label"/>
}

ActivationChangeDateField.propTypes = {
  ...useField.propTypes
}

export default observer(withTranslations(ActivationChangeDateField))